/* eslint-disable @next/next/no-img-element */
'use client';

import { FC, ImgHTMLAttributes } from 'react';
import { cn } from '@/utils';

export type ListingProductImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  /** Only the single LCP candidate — avoids preload/fetchPriority storms. */
  priority?: boolean;
};

/**
 * Plain `<img>` for PLP cards so HeroUI/Next do not emit `<link rel="preload">`
 * for every grid image. Non-priority cards always lazy-load.
 */
export const ListingProductImage: FC<ListingProductImageProps> = ({
  src,
  alt,
  priority = false,
  className,
  ...rest
}) => (
  <img
    src={src}
    alt={alt}
    decoding="async"
    className={cn('h-full w-full object-cover', className)}
    {...(priority
      ? { fetchPriority: 'high' as const, loading: 'eager' as const }
      : { loading: 'lazy' as const })}
    {...rest}
  />
);

export default ListingProductImage;
